import React from "react";
import {
    IhioPrescriptionAdmissionType,
    IhioWrittenPrescriptionInfoType,
    IhioWrittenPrescriptionItemType
} from "../../../../../types/ihioPrescriptionFilling";
import BoxLoader from "../../../general/boxLoader";
import WrittenPrescriptionItemCard from "./writtenPrescriptionItemCard";

type PrescriptionFillingWrittenPrescriptionDetailsProps = {
    prescriptionAdmissionData: IhioPrescriptionAdmissionType;
    writtenPrescriptionData: IhioWrittenPrescriptionInfoType | null;
    itemsToFulfil: Record<string, IhioWrittenPrescriptionItemType>;
    handleAddItemToFulfil: (UUID: string, item: IhioWrittenPrescriptionItemType) => void;
    handleRemoveItemFromFulfil: (UUID: string) => void;
    isLoading: boolean;
}

const PrescriptionFillingWrittenPrescriptionDetails = ({
    prescriptionAdmissionData,
    writtenPrescriptionData,
    itemsToFulfil,
    handleAddItemToFulfil,
    handleRemoveItemFromFulfil,
    isLoading
}: PrescriptionFillingWrittenPrescriptionDetailsProps) => {

    return(
        <>
            <div className={'tw-relative w-100 rounded rounded-4 border bg-white mt-4 py-3 px-4'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div className='fs-5 tw-font-[600]'>
                        نسخه نوشته شده توسط پزشک
                    </div>
                </div>
                <div className={'mt-3 d-flex flex-column gap-3'}>
                    {writtenPrescriptionData?.items?.map((item) => {
                        return(
                            <WrittenPrescriptionItemCard
                                key={item?.UUID}
                                item={item}
                                creationDate={writtenPrescriptionData?.creationDate}
                                isReadyToFulfil={!!item?.UUID && !!itemsToFulfil && item.UUID in itemsToFulfil}
                                handleAddItemToFulfil={handleAddItemToFulfil}
                                handleRemoveItemFromFulfil={handleRemoveItemFromFulfil}
                            />
                        )
                    })}
                </div>
            </div>
        </>
    )
}


export default PrescriptionFillingWrittenPrescriptionDetails;